import CartButton from '@components/cart/CartButton';
import Header from '@components/Header';
import TabItem from '@components/tab/TabItem';
import TabList from '@components/tab/TabList';
import { useStepFlow } from '@router/stackflow';
import { AppScreen } from '@stackflow/plugin-basic-ui';
import { ActivityComponentType } from '@stackflow/react';

import ItemHeader from './components/ItemHeader';
import ShopItemContext from './context/ShopItemContext';
import AllMenuFragment from './fragments/AllMenuFragment';
import MyMenuFragment from './fragments/MyMenuFragment';

interface Params {
    shopId: string;
    categoryId?: string;
    type: 'ALL' | 'MY_MENU',
}

const ItemsActivity: ActivityComponentType<Params> = ({ params }:{params: Params}) => {
  const {
    shopId, categoryId, type,
  } = params;
  const { stepReplace } = useStepFlow('ItemsActivity');
  const changeTab = (newType: typeof type) => {
    stepReplace({
      shopId, categoryId, type: newType,
    });
  };
  return (
      <AppScreen>
          {/*
          <Header title='주문하기'
                  trailing={<CartButton shopId={shopId} />} /> */}
          <ItemHeader shopId={shopId}/>
          {/*
          <TabList>
              <TabItem selected={type === 'ALL'}
                       onClick={() => changeTab('ALL')} >
                  전체 메뉴
              </TabItem>
              <TabItem selected={type === 'MY_MENU'}
                       onClick={() => changeTab('MY_MENU')} >
                  MY 메뉴
              </TabItem>
          </TabList>
          */}
          <ShopItemContext value={{ shopId, categoryId }}>
              {/*
              {type === 'ALL' && (
                  <AllMenuFragment />
              )}
              {type === 'MY_MENU' && (
                  <MyMenuFragment/>
              )}
              */}
              <AllMenuFragment />
          </ShopItemContext>

      </AppScreen>
  );
};

export default ItemsActivity;
